export default {
  currentUser: {
    id: '',
    role: '',
    name: '',
    email: '',
  },
  definedAbilites: null,
}
